import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const QuoteExperienceOptionStyled = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
`;

export const DescriptionBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const DescriptionBlockTitleStyled = styled.h3`
  ${typography.bold[16]}
  color: ${colors.neutral[900]};
  margin: 0;
`;

export const DescriptionBlockDescriptionStyled = styled.p`
  ${typography.regular[16]}
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const IconWrapperStyled = styled.div<{ $accentColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 5rem;
  height: 5rem;
  background-color: ${({ $accentColor }): string => $accentColor};
  border-radius: 10px;
  padding: 0.5rem;
  box-sizing: border-box;
`;
